export default __webpack_public_path__ + "static/media/img-2.b00d6c19.svg";